/*!
 * Copyright © 2020-21 Robert Bosch Engineering and Business Solutions Private Limited. All Rights Reserved.
NOTICE:  All information contained herein is, and remains the property of Robert Bosch Engineering and Business Solutions Private Limited.
Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained from
Robert Bosch Engineering and Business Solutions Private Limited.
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ManageUserComponent } from './manage-user/manage-user.component';
import { CanAuthenticationGuard } from '../providers/auth-guard';

/**
  * @ngdoc overview
  * @name UsersModule.module:UsersRoutingModule
  *
  * @description
  * description: To route to different components in users module based on the path given
*/
const routes: Routes = [
  {
    path: 'users/manage-users',
    component: ManageUserComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'USR_R', data: {} }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsersRoutingModule { }
